module.exports = __webpack_public_path__ + "static/media/zadania-powtorkowe-klasa6-powtorkomat-1.6f539160.jpg";